import { render } from "./CountdownClock.vue?vue&type=template&id=ba01ba30"
import script from "./CountdownClock.vue?vue&type=script&lang=js"
export * from "./CountdownClock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__